import { Translation, QRType } from '../types';

export const pt: Translation = {
  nav: {
    generator: 'Gerador',
    scanner: 'Scanner',
    mobile: 'Testar no celular',
    blog: 'Blog',
    langSelect: 'Selecione o idioma',
  },
  pageTitles: {
    generator: 'Gerador de QR Code Grátis Online',
    scanner: 'Scanner de QR Code Online',
    textToQr: 'Conversor de Texto em QR Code',
    linkToQr: 'Gerador de QR Code para Links',
  },
  pageMeta: {
    generator: {
      title:
        'Gerador de QR Code Gratuito — Crie QR Codes Online (Sem Cadastro, Sem Marca-d’água, PNG/SVG/PDF) | YesQRCode',
      description:
        'Crie QR codes online gratuitamente com o YesQRCode. Gere URLs, textos, Wi-Fi, vCard e muito mais. Baixe PNG, SVG ou PDF em alta qualidade. Sem cadastro, sem login, sem marca d’água — rápido, seguro e para sempre grátis.',
      keywords: [
        'gerador de qr code',
        'gerador de qr code grátis',
        'criar qr code online',
        'criador de qr code',
        'qr code png',
        'qr code svg',
        'qr code pdf',
        'gerador de qr wifi',
        'gerador de qr vcard',
        'gerador qr sem cadastro',
      ],
    },
    scanner: {
      title:
        'Scanner de QR Code Online — Escaneie por Imagem ou Câmera (Seguro, Sem Cadastro) | YesQRCode',
      description:
        'Escaneie códigos QR e códigos de barras online gratuitamente. Envie uma imagem ou use a câmera. Todo o processamento é local, sem uploads. Seguro, rápido, sem cadastro, sem login e totalmente gratuito.',
      keywords: [
        'leitor de qr code',
        'escanear qr code online',
        'leitor qr online',
        'escanear qr por imagem',
        'ler código de barras online',
        'scanner qr seguro',
        'scanner qr sem upload',
        'scanner qr grátis',
        'scanner qr no navegador',
        'scanner qr sem cadastro',
      ],
    },
    textToQr: {
      title: 'Conversor de Texto para QR Code — Transforme Texto em QR Instantaneamente | YesQRCode',
      description:
        'Converta notas, mensagens ou qualquer texto em códigos QR online. Personalize cores, molduras e logotipos e baixe em PNG, SVG ou PDF sem cadastro e sem marca d’água.',
      keywords: [
        'texto para qr code',
        'converter texto em qr',
        'gerador qr de texto',
        'qr code de mensagem',
        'nota para qr code',
        'qr code texto online',
        'qr code texto grátis',
        'texto qr sem cadastro',
        'convert text qr portugues',
        'qr code para texto',
      ],
    },
    linkToQr: {
      title: 'Gerador de Link em QR Code — Converta URLs em QR (Pronto para UTM) | YesQRCode',
      description:
        'Cole qualquer URL de site ou campanha e gere um QR code com sua identidade visual. Suporte a cores personalizadas, logotipos e download em alta resolução sem login.',
      keywords: [
        'link para qr code',
        'converter url em qr',
        'gerador qr de link',
        'qr code para site',
        'qr code url',
        'qr utm',
        'link qr gratuito',
        'qr code para campanha',
        'url qr sem cadastro',
        'gerar qr para site',
      ],
    },
  },
  hero: {
    title: 'Gerar. Escanear. Criar.',
    subtitle: 'A ferramenta premium de QR Code para todos.',
    desc: 'Crie códigos QR totalmente personalizáveis com logotipos, cores e arquivos em alta resolução em segundos.',
  },
  info: {
    helpTitle: 'Central de Ajuda',
    helpSubtitle: 'Perguntas frequentes e suporte',
    contactTitle: 'Fale Conosco',
    contactSubtitle: 'Nossa equipe responde rapidamente.',
    privacyTitle: 'Política de Privacidade',
    termsTitle: 'Termos de Serviço',
  },
  contactForm: {
    name: 'Nome',
    email: 'E-mail',
    message: 'Mensagem',
    send: 'Enviar mensagem',
    orEmail: 'ou envie diretamente para',
    sending: 'Enviando...',
    successTitle: 'Mensagem enviada!',
    successMessage: 'Obrigado pelo contato. Retornaremos em breve.',
    sendAnother: 'Enviar outra mensagem',
    errorMessage: 'Não foi possível enviar sua mensagem agora. Escreva para support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Crie QR codes privados e prontos para a marca — grátis para sempre.',
      subtitle: 'Uma ferramenta rápida, privada e flexível para qualquer fluxo de trabalho.',
      desc: 'Gere e escaneie QR codes em alta qualidade sem contas, marcas-d’água ou upload de dados.',
      items: [
        {
          title: 'Privacidade em primeiro lugar, geração local',
          desc: 'Os QR são criados no seu dispositivo — sem envio, rastreamento ou armazenamento.',
        },
        {
          title: 'Recursos completos para todo uso',
          desc: 'URLs, Wi-Fi, vCards, códigos de barras, logos, gradientes e molduras já incluídos.',
        },
        {
          title: 'Experiência mobile para todos',
          desc: 'Interface otimizada para celulares e gestos touch para criar e escanear sem atrito.',
        },
        {
          title: 'Grátis para sempre e seguro para negócios',
          desc: 'Sem contas, sem marcas-d’água e sem limite de leitura — confiável para equipes e marcas.',
        },
      ],
    },
    featureSuite: {
      title: 'A suíte completa de QR codes focada em privacidade',
      subtitle: 'Tudo o que você precisa para criar QR limpos, com marca e de alta qualidade em um só lugar.',
      categories: [
        {
          title: 'Todos os tipos de QR que você precisa',
          body: 'URL, texto, Wi-Fi, e-mail, telefone, SMS, vCard, links sociais, YouTube e códigos de barras. Códigos estáticos que nunca expiram.',
          items: [],
        },
        {
          title: 'Branding & design',
          body: 'Códigos seguros para logos, gradientes, molduras, formas, cantos e layouts otimizados para leitura.',
          items: [],
        },
        {
          title: 'Saída & qualidade',
          body: 'Exportações PNG, SVG e PDF em alta resolução com presets para impressão e digital.',
          items: [],
        },
        {
          title: 'Global & usabilidade',
          body: 'Interface multilíngue, design mobile-first e fluxo que funciona até mesmo offline.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'Conteúdo',
    sectionColors: 'Cores',
    sectionLogo: 'Logo',
    sectionFrame: 'Moldura',
    sectionDesign: 'Design',
    sectionCorrection: 'Correção de erro',
    labelUrl: 'URL do site',
    labelText: 'Texto simples',
    labelSsid: 'Nome da rede (SSID)',
    labelPassword: 'Senha',
    labelEncryption: 'Criptografia',
    labelFgColor: 'Cor principal',
    labelBgColor: 'Cor de fundo',
    labelFrameText: 'Texto da moldura',
    labelFrameColor: 'Cor da moldura',
    placeholder: 'Digite o conteúdo aqui...',
    placeholders: {
      url: 'https://exemplo.com',
      text: 'Digite seu texto',
      email: 'voce@email.com',
      subject: 'Assunto',
      message: 'Sua mensagem...',
      phone: '+55 11 0000-0000',
      ssid: 'MinhaRede',
      password: 'Sua senha',
      barcode: '123456789012',
    },
    download: 'Baixar PNG',
    downloadSvg: 'Baixar SVG',
    generateButton: 'Gerar QR Code',
    copy: 'Copiar SVG',
    uploadLogo: 'Enviar imagem',
    preview: 'Pré-visualização',
    lowQuality: 'Baixa qualidade',
    highQuality: 'Alta qualidade',
    foreverFree: 'Grátis para sempre • Sem cadastro • Uso comercial liberado',
    barcodeWarning: 'Opções avançadas de design como logo e moldura não estão disponíveis para códigos de barras.',
    barcodeColors: 'Você ainda pode personalizar as cores abaixo.',
    frameStyles: {
      none: 'Sem moldura',
      simple: 'Simples',
      balloon: 'Balão',
      box: 'Caixa',
      badge: 'Selo',
      polaroid: 'Polaroid',
      phone: 'Telefone',
      header: 'Cabeçalho',
      corner: 'Cantoneira',
    },
    vCard: {
      firstName: 'Nome',
      lastName: 'Sobrenome',
      mobile: 'Celular',
      phone: 'Telefone',
      fax: 'Fax',
      email: 'E-mail',
      company: 'Empresa',
      job: 'Cargo',
      street: 'Rua',
      city: 'Cidade',
      zip: 'CEP',
      state: 'Estado',
      country: 'País',
      website: 'Site',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Texto',
      [QRType.EMAIL]: 'E-mail',
      [QRType.PHONE]: 'Telefone',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi-Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Código de barras',
    },
    guide: {
      title: 'Como criar um QR Code personalizado?',
      steps: [],
    },
    gettingStarted: {
      title: 'Comece em 4 passos',
      steps: [
        {
          title: 'Defina o conteúdo',
          text: 'Escolha o tipo de QR Code (URL, texto, e-mail, Wi-Fi e mais) e preencha todos os campos que serão exibidos ao escanear.',
        },
        {
          title: 'Personalize o design',
          text: 'Troque cores, formatos e adicione seu logotipo para combinar o QR com a identidade visual da sua marca.',
        },
        {
          title: 'Gere o QR Code',
          text: 'Selecione a resolução desejada, visualize o resultado em tempo real e faça testes com o scanner integrado.',
        },
        {
          title: 'Baixe e use',
          text: 'Exporte em PNG ou SVG pronto para impressão, embalagens, materiais digitais ou campanhas.',
        },
      ],
    },
    about: {
      title: 'O gerador de QR Code gratuito para uso profissional',
      subtitle:
        'YesQRCode oferece qualidade de impressão, inúmeras opções visuais e liberdade total para criar QR Codes estáticos sem expiração.',
      features: [
        'QR Codes para redes sociais',
        'Cartão de visita digital (vCard)',
        'Integração com campanhas de marketing',
        'Personalização avançada de cores',
        'Compatível com impressão de alta tiragem',
        'Escaneamentos ilimitados para sempre',
      ],
      content: [
        {
          title: 'Vida útil ilimitada',
          body: 'Seus QR Codes são estáticos e nunca expiram. Gere uma vez e mantenha funcionando para sempre, sem limite de escaneamentos.',
        },
        {
          title: 'QR Codes com logotipo',
          body: 'Adicione facilmente o logo da sua marca aproveitando até 30% de correção de erro para manter o QR perfeitamente legível.',
        },
        {
          title: 'Design completo',
          body: 'Escolha formatos diferentes para olhos e corpo do QR, ative gradientes, fundos e molduras chamativas que aumentam o engajamento.',
        },
        {
          title: 'Qualidade para impressão',
          body: 'Baixe arquivos PNG em alta resolução ou SVG vetorial para usar em banners, embalagens e materiais editoriais sem perda de nitidez.',
        },
        {
          title: 'Uso comercial liberado',
          body: 'Todos os QR Codes podem ser utilizados em campanhas pagas, rótulos de produtos e projetos corporativos sem custos adicionais.',
        },
      ],
    },
    faq: {
      title: 'Perguntas frequentes',
      items: [
        {
          q: 'O que é um QR Code?',
          a: 'QR significa Quick Response. É um código bidimensional criado no Japão em 1994 para armazenar texto ou links.',
        },
        {
          q: 'Os QR Codes gerados são gratuitos?',
          a: 'Sim. Você pode criar e usar quantos precisar em projetos pessoais ou comerciais.',
        },
        {
          q: 'Posso editar o QR depois?',
          a: 'Os códigos são estáticos; não é possível editar o conteúdo após impressão. Gere um novo QR se precisar atualizar.',
        },
        {
          q: 'Existe limite de escaneamentos?',
          a: 'Não. O QR pode ser escaneado infinitas vezes sem custo.',
        },
        {
          q: 'Vocês armazenam meus dados?',
          a: 'Não. Apenas armazenamos temporariamente as imagens para agilizar o download e elas são removidas automaticamente.',
        },
        {
          q: 'Por que o vCard não abre corretamente?',
          a: 'Alguns apps não seguem o padrão oficial vCard. Teste com outro leitor para garantir a compatibilidade.',
        },
        {
          q: 'Meu QR não funciona, o que fazer?',
          a: 'Verifique se não há erros de digitação, se o contraste é suficiente (fundo claro e frente escura) e teste sem logotipo.',
        },
        {
          q: 'Funciona em todos os navegadores?',
          a: 'Sim, recomendamos Chrome, Firefox, Safari ou Edge atualizados.',
        },
      ],
    },
  },
  scanner: {
    title: 'Escanear QR e códigos de barras',
    subtitle: 'Use a câmera, faça upload ou cole imagens para decodificar instantaneamente.',
    cameraPermission: 'Permita o acesso à câmera nas configurações do navegador para continuar.',
    result: 'Resultado',
    copy: 'Copiar',
    copied: 'Copiado',
    open: 'Abrir link',
    delete: 'Excluir',
    scanAgain: 'Escanear outro',
    privacy: 'Todo o processamento acontece localmente. Suas imagens não são enviadas para nossos servidores.',
    upload: 'Enviar imagem',
    paste: 'Colar (Ctrl+V)',
    drop: 'Solte a imagem aqui',
    retry: 'Tentar novamente',
    errorAccessDenied: 'Acesso à câmera negado',
    errorCamera: 'Ative o acesso à câmera no navegador e tente novamente.',
    initializing: 'Inicializando câmera...',
    cameraActive: 'Câmera ativa',
    scannedItems: 'Itens escaneados',
    recentScans: 'Recentes (salvos localmente)',
    clickToUpload: 'Clique para enviar',
    newBadge: 'NOVO',
    tabCameraMobile: 'Câmera',
    tabCameraDesktop: 'Escanear com câmera',
    emptyState: {
      title: 'Nenhum escaneamento ainda',
      desc: 'Envie uma imagem ou acesse a aba câmera para começar.',
    },
    highlights: {
      title: 'Escaneamento rápido e privado',
      items: [
        { title: 'Decodificação no dispositivo', desc: 'Sem uploads por padrão; seguro para URLs e ativos sensíveis.' },
        { title: 'Multi-formato', desc: 'QR mais UPC/EAN, Code 128, ITF e outros padrões conhecidos.' },
        { title: 'Ações rápidas', desc: 'Solte arquivos, cole capturas ou mude para o scan ao vivo na hora.' },
        { title: 'Excelente no mobile', desc: 'UI e fluxo da câmera otimizados para celulares e telas pequenas.' },
      ],
    },
    intro: {
      title: 'Scanner online seguro',
      body: 'Decodifique QR Codes, UPC, EAN, ITF e outros formatos diretamente no navegador.',
    },
    howTo: {
      title: 'Como escanear',
      methods: [
        {
          title: 'Método 1: Upload',
          steps: ['Clique em “Enviar imagem”', 'Escolha o arquivo', 'Confira o resultado instantâneo'],
        },
        {
          title: 'Método 2: Câmera',
          steps: ['Abra a aba “Câmera”', 'Permita o acesso', 'Aponte para o código e aguarde a leitura'],
        },
      ],
    },
    features: {
      title: 'Por que usar?',
      items: [
        { title: 'Gratuito e ilimitado', desc: 'Nenhum paywall ou limitação de escaneamentos.' },
        { title: 'Vários formatos', desc: 'Lê QR, Code 128, EAN, UPC, ITF, entre outros.' },
        { title: 'Privacidade garantida', desc: 'Nada é enviado para servidores externos.' },
      ],
    },
    useCases: {
      title: 'Casos de uso',
      items: [
        { title: 'Campanhas e marketing', desc: 'Valide materiais impressos e cupons digitais.' },
        { title: 'Logística e estoque', desc: 'Faça auditorias rápidas de códigos de barras.' },
        { title: 'Uso diário', desc: 'Abra cardápios, formulários e redes Wi-Fi com segurança.' },
      ],
    },
    faq: {
      title: 'Dúvidas sobre o scanner',
      items: [
        { q: 'Funciona com códigos de barras?', a: 'Sim. Suporta formatos lineares e bidimensionais populares.' },
        { q: 'Posso colar capturas de tela?', a: 'Sim. Use Ctrl+V (ou Cmd+V) e o arquivo será processado automaticamente.' },
        { q: 'Os resultados ficam salvos?', a: 'Eles permanecem apenas no seu dispositivo e podem ser limpos manualmente.' },
        { q: 'Posso usar offline?', a: 'Uploads funcionam offline; a câmera exige permissão e suporte do navegador.' },
      ],
    },
  },
  blog: {
    title: 'Insights e Guias',
    subtitle: 'Dicas de marketing, ideias criativas e novidades sobre QR Codes.',
    readMore: 'Ler artigo',
    back: 'Voltar para o blog',
    notFound: 'Artigo não encontrado',
  },
  common: {
    footer: 'Suite completa para criar e rastrear QR Codes profissionais.',
    privacy: 'Privacidade',
    terms: 'Termos',
    contact: 'Contato',
    scanToOpen: 'Escaneie para abrir no celular',
    help: 'Ajuda',
    free: 'Grátis',
    product: 'Produto',
    resources: 'Recursos',
    company: 'Empresa',
    api: 'API (em breve)',
    systemStatus: 'Sistemas operando normalmente',
    footerDesc:
      'O gerador e scanner de QR Code mais avançado. Rápido, privado e gratuito para sempre, ideal para marcas, agências e criadores.',
  },
};
